// /* eslint-disable no-negated-condition */
// /* eslint-disable jsx-a11y/click-events-have-key-events */
// /* eslint-disable jsx-a11y/no-static-element-interactions */
// /* eslint-disable no-else-return */
// /* eslint-disable react-hooks/exhaustive-deps */
// import React, { useEffect, useState } from 'react';
// import { toast } from 'react-toastify';
// import { useDispatch, useSelector } from 'react-redux';
// import { useMutation, useQuery } from '@apollo/client';
// import { FSBTable } from 'components/common/FSBTable';
// import {
//   DELETE_ORDER,
//   EXPORTS_ORDERS,
//   ORDERED,
//   ORDERS_SUBSCRIPTION,
//   UPDATE_ORDER_STATUS,
//   UPDATE_PAYMENT_STATUS,
// } from 'pages/Orders/OrdersGraphQL';
// import {
//   defaultDeleteFilter,
//   ORDER_STATUS,
//   PAYMENT_STATUS,
//   USER_ID,
//   showSequenceNumber,
//   VENDOR_ORDER_STATUS,
//   handlePaymentStatusColor,
// } from 'utils/constants';
// import {
//   RECORD_DELETED_SUCCESSFULLY,
//   STATUS_UPDATED_SUCCESSFULLY,
// } from 'components/common/FSBToastify/types';
// import { setOrderDetails, toggleModal } from 'actions/orderDetailsAction';
// import { setInvoiceListByOrderId } from 'actions/invoiceListByOrderIdAction';
// import { cloneDeep, isEmpty } from 'lodash';
// import { orderedColumns } from 'pages/Orders/constant';
// import { setUserDetails } from 'actions/userDetailsAction';
// import { role } from 'config/role';
// import StatusFormatter from 'components/StatusFormatter';
// import FSBModal from 'components/common/FSBModal';
// import EditOrderWrapper from 'pages/Orders/components/EditOrderWrapper';
// import DeleteConfirmationAlert from 'components/DeleteConfirmationAlert';
// import ActionsFormatter from 'components/ActionsFormatter';
// import Loader from 'components/common/Loader';
// import DownloadCSV from 'components/DownloadCSV';
// import ErrorMessage from 'components/ErrorMessage';
// import NoDataFound from 'components/NoDataFound';
// import RBAC from 'hoc/RBAC';
// import FilterResultBar from 'components/FilterResultBar';
// import PendingOrdersWrapper from 'pages/Orders/components/PendingOrders';

// import EditDeliveredQuantity from '../EditDeliveredQuantity';

// const OrderedTable = ({
//   searchString,
//   filterValue,
//   defaultValue,
//   showAdvancedSearchBar = false,
//   handleResetFilter = () => {},
// }) => {
//   const dispatch = useDispatch();
//   const [deleteRowId, setDeleteRowId] = useState('');
//   const [updateOrderModal, setUpdateOrderModal] = useState(false);
//   const [selectedOrderRow, setSelectedOrderRow] = useState('');
//   const [showDeleteRecord, setDeleteRecord] = useState(false);
//   const [showQuantity, setShowQuantity] = useState(false);

//   const { pendingOrders } = useSelector(
//     (state) => state.orderDetailsReducer,
//   );

//   const [showDeliveredStatusRecord, setShowDeliveredStatusRecord] = useState({
//     id: '',
//     orderStatus: '',
//     status: false,
//     row: '',
//   });

//   const [filters, setFilters] = useState({
//     filter: [
//       {
//         key: 'entityName',
//         joinAttributeName: 'seller',
//         value: searchString,
//         type: 'STRING',
//         op: 'LIKE_OR_NULL',
//       },
//       // {
//       //   key: 'status',
//       //   value: 'DELIVERED',
//       //   type: 'STRING',
//       //   op: 'NEQ',
//       // },
//       { ...defaultDeleteFilter },
//       ...defaultValue,
//     ],
//     pageNo: 1,
//     pageSize: 10,
//     sortCol: 'createdAt',
//     sortDirection: 'DESC',
//   });
//   const { data, loading, error, refetch, subscribeToMore } = useQuery(ORDERED, {
//     variables: {
//       ...filters,
//       filter: [...filters.filter, ...filterValue],
//     },
//     fetchPolicy: 'network-only',
//   });

//   const [deleteOrder] = useMutation(DELETE_ORDER, {
//     // eslint-disable-next-line no-shadow
//     onCompleted: ({ deleteOrder }) => {
//       if (deleteOrder) {
//         toast.success(RECORD_DELETED_SUCCESSFULLY);
//         setDeleteRecord(false);
//         setDeleteRowId('');
//       }
//     },
//     onError: ({ graphQLErrors }) => {
//       graphQLErrors.map(({ exception }) => {
//         toast.error(exception?.message);
//         return exception;
//       });
//       setDeleteRecord(false);
//       setDeleteRowId('');
//     },
//   });

//   const [updateOrderStatus] = useMutation(UPDATE_ORDER_STATUS, {
//     // eslint-disable-next-line no-shadow
//     onCompleted: () => {
//       toast.success(STATUS_UPDATED_SUCCESSFULLY);
//     },
//     onError: ({ graphQLErrors }) => {
//       graphQLErrors.map(({ exception }) => {
//         toast.error(exception?.message);
//         return exception;
//       });
//     },
//   });

//   const [updateOrderPaymentStatus] = useMutation(UPDATE_PAYMENT_STATUS, {
//     // eslint-disable-next-line no-shadow
//     onCompleted: ({ updateOrderPaymentStatus }) => {
//       toast.success(updateOrderPaymentStatus);
//     },
//     onError: ({ graphQLErrors }) => {
//       graphQLErrors.map(({ exception }) => {
//         toast.error(exception?.message);
//         return exception;
//       });
//     },
//   });

//   // Hnadle on edit icon click at action column
//   const onClickEdit = (row) => {
//     setUpdateOrderModal(true);
//     setSelectedOrderRow(row);
//   };

//   const onCloseOrderPopup = () => {
//     setUpdateOrderModal(false);
//     refetch();
//     setSelectedOrderRow('');
//   };

//   const onClosePendingActions = () => {
//     dispatch(toggleModal({ showForm: false}))
//   }

//   const toggleDeleteRecord = (row) => {
//     setDeleteRecord(!showDeleteRecord);
//     setDeleteRowId(row);
//   };
//   const toggleOnCancel = () => {
//     setDeleteRecord(false);
//     setDeleteRowId('');
//   };
//   const onDeleteConfirmation = async () => {
//     // if (
//     //   deleteRowId?.approvalStatus === 'ORDER_APPROVAL_EXPIRED' ||
//     //   deleteRowId?.approvalStatus === 'ORDER_REJECTED'
//     // ) {
//     if (deleteRowId?.approvalStatus !== 'ORDER_APPROVED') {
//       try {
//         await deleteOrder({
//           variables: { id: deleteRowId?.id },
//         });
//       } catch (e) {
//         console.error(e);
//       }
//     } else {
//       setDeleteRecord(false);
//       setDeleteRowId('');
//       toast.warn("Approved order can't be deleted");
//     }

//     // } else {
//     //   setDeleteRecord(false);
//     //   setDeleteRowId('');
//     // }
//   };

//   const handleViewDetail = (row) => {
//     dispatch(setOrderDetails({ status: true, selectedOrder: row }));
//   };

//   const handleOrderLinkClick = (row) => {
//     dispatch(setInvoiceListByOrderId({ status: true, selectedOrderId: row }));
//   };

//   const actionsFormatter = (cell) => {
//     return (
//       <ActionsFormatter
//         // isDelete={
//         //   cell?.row?.original?.approvalStatus === 'ORDER_APPROVAL_EXPIRED' ||
//         //   cell?.row?.original?.approvalStatus === 'ORDER_REJECTED'
//         // }
//         handleDelete={() => toggleDeleteRecord(cell?.row?.original)}
//         handleView={() => handleOrderLinkClick(cell?.row?.original)}
//         handleEdit={() => onClickEdit(cell?.row?.original)}
//       />
//     );
//   };

//   const handlePaymentStatusChange = async (e, cell) => {
//     if (cell?.row?.original?.approvalStatus === 'ORDER_APPROVED') {
//       try {
//         await updateOrderPaymentStatus({
//           variables: {
//             id: cell?.row?.original?.id,
//             paymentStatus: e.target.value,
//           },
//         });
//         refetch();
//       } catch (err) {
//         toast.error(err);
//       }
//     } else {
//       toast.error('Cannot update status before order approval');
//     }
//   };

//   const paymentStatusFormatter = (cell) => {
//     return (
//       <RBAC allowedRoles={[role.SUPER_ADMIN, role.ACCOUNT]} disabled>
//         {({ access }) => (
//           <StatusFormatter
//             options={PAYMENT_STATUS}
//             defaultValue={cell?.row?.original?.paymentStatus}
//             handleChange={(e) => handlePaymentStatusChange(e, cell)}
//             onChange={(e) => handlePaymentStatusChange(e, cell)}
//             inputDisabled={!access}
//             isStatus
//             handleSelectColor={handlePaymentStatusColor}
//           />
//         )}
//       </RBAC>
//     );
//   };

//   const toggleDeliveredStatusRecord = (id = '', orderStatus = '', row = '') => {
//     setShowDeliveredStatusRecord({
//       id,
//       orderStatus,
//       status: !showDeliveredStatusRecord?.status,
//       row,
//     });
//   };

//   const handleOrderStatus = async (id, status, deliveredQuantity = null) => {
//     try {
//       await updateOrderStatus({
//         variables: { id, status, deliveredQuantity },
//       });
//       refetch();
//     } catch (err) {
//       toast.error(err);
//     }
//   };

//   const onDeliveredStatusConfirmation = (deliveredQuantity = null) => {
//     handleOrderStatus(
//       showDeliveredStatusRecord?.id,
//       showDeliveredStatusRecord?.orderStatus,
//       deliveredQuantity,
//     );
//     toggleDeliveredStatusRecord('', '', '');
//   };

//   const handleStatusChange = (e, cell) => {
//     if (cell?.row?.original?.approvalStatus === 'ORDER_APPROVED') {
//       if (e.target.value === 'DELIVERED') {
//         if (cell?.row?.original?.pendingQuantity > 0) {
//           if (cell?.row?.original?.approvalStatus === 'ORDER_APPROVED') {
//             toggleDeliveredStatusRecord(
//               cell?.row?.original?.id,
//               e.target.value,
//               cell?.row?.original,
//             );
//           } else {
//             toast.warn("Order can't be delivered until approved");
//           }
//         } else {
//           toast.warn(
//             "Order can't be delivered until quantity is greater than 0",
//           );
//         }
//       } else {
//         handleOrderStatus(cell?.row?.original?.id, e.target.value, null);
//       }
//     } else {
//       toast.error('Cannot update status before order approval');
//     }
//   };

//   const handleOrderStatusColor = (value) => {
//     return VENDOR_ORDER_STATUS[value] || '';
//   };

//   const statusFormatter = (cell) => {
//     return (
//       <RBAC allowedRoles={[role.SUPER_ADMIN, role.LOGISTICS]} disabled>
//         {({ access }) => (
//           <StatusFormatter
//             options={ORDER_STATUS}
//             defaultValue={cell?.row?.original?.status}
//             handleChange={(e) => handleStatusChange(e, cell)}
//             onChange={(e) => handleStatusChange(e, cell)}
//             isDisabledOption
//             isStatus
//             inputDisabled={!access}
//             handleSelectColor={handleOrderStatusColor}
//           />
//         )}
//       </RBAC>
//     );
//   };

//   const linkFormatter = (cell) => {
//     return (
//       <div
//         className="text-blue-c5 fw-medium cursor-pointer"
//         onClick={() => handleViewDetail(cell?.row?.original)}
//         aria-hidden
//       >
//         {cell?.row?.original?.id}
//       </div>
//     );
//   };

//   const handleUserId = (row, id) => {
//     dispatch(setUserDetails({ status: true, selectedUser: { ...row, id } }));
//   };

//   const linkFormatterForUserId = (cell, userId) => {
//     return (
//       <div
//         className="text-blue-c5 fw-medium cursor-pointer"
//         onClick={() =>
//           handleUserId(cell?.row?.original, cell?.row?.original?.[userId])
//         }
//         aria-hidden
//       >
//         {cell?.row?.original?.[userId]}
//       </div>
//     );
//   };

//   const findIndexOfItem = (item) => {
//     const findIndex = orderedColumns.findIndex(
//       (itm) => itm.accessorKey === item,
//     );
//     return findIndex;
//   };
//   orderedColumns[findIndexOfItem('actions')].cell = actionsFormatter;
//   // orderedColumns[findIndexOfItem('status')].cell = statusFormatter;
//   orderedColumns[findIndexOfItem('PaymentStatus')].cell =
//     paymentStatusFormatter;

//   orderedColumns[findIndexOfItem('id')].cell = linkFormatter;
//   orderedColumns[findIndexOfItem('SNo')].cell = (cell) =>
//     showSequenceNumber(cell, filters);
//   orderedColumns[findIndexOfItem(USER_ID.CREATED_ID)].cell = (cell) =>
//     linkFormatterForUserId(cell, USER_ID.CREATED_ID);
//   orderedColumns[findIndexOfItem(USER_ID.UPDATED_ID)].cell = (cell) =>
//     linkFormatterForUserId(cell, USER_ID.UPDATED_ID);

//   const onSortChange = (sort) => {
//     setFilters({
//       ...filters,
//       sortCol: sort()[0].id,
//       sortDirection: sort()[0].desc ? 'DESC' : 'ASC',
//     });
//   };
//   const handlePageChange = ({ pageSize, pageNo }) => {
//     setFilters({
//       ...filters,
//       pageNo,
//       pageSize,
//     });
//   };

//   const sortBy = [
//     filters.sortCol === null
//       ? { id: null, desc: null }
//       : {
//           id: filters.sortCol,
//           desc: filters.sortDirection === 'DESC',
//         },
//   ];

//   useEffect(() => {
//     const updatedFilter = [...filters.filter]; // Clone the filter array
//     const updatedFirstFilter = { ...updatedFilter[0] }; // Clone the 0th filter object
//     updatedFirstFilter.value = searchString;
//     updatedFilter[0] = updatedFirstFilter; // Replace the 0th filter with the updated one
//     // return { ...prevFilter, filter: updatedFilter }; // Update the filter property in the state
//     refetch({ ...filters, filter: updatedFilter });
//   }, [searchString]);

//   const onGlobalSearch = (str) => {
//     if (str) {
//       setFilters((prevFilter) => {
//         const updatedFilter = [...prevFilter.filter]; // Clone the filter array
//         const updatedFirstFilter = { ...updatedFilter[0] }; // Clone the 0th filter object
//         updatedFirstFilter.value = str;
//         updatedFilter[0] = updatedFirstFilter; // Replace the 0th filter with the updated one
//         return { ...prevFilter, filter: updatedFilter }; // Update the filter property in the state
//       });
//     }
//   };

//   useEffect(() => {
//     const unsubscribe = subscribeToMore({
//       document: ORDERS_SUBSCRIPTION,
//       variables: { ...filters, filter: [...filters.filter, ...filterValue] },
//       updateQuery: (prev, { subscriptionData }) => {
//         const newData = cloneDeep(prev);
//         const indexFound = newData.orders.orders.findIndex(
//           (val) => val.id === subscriptionData.data.orders.order.id,
//         );
//         if (!prev || isEmpty(prev)) return '';
//         if (!subscriptionData.data) return prev;
//         if (!subscriptionData.data?.orders?.order) return prev;
//         if (subscriptionData.data.orders.action === 'CREATED') {
//           const newOrder = subscriptionData.data.orders.order;
//           const updatedOrders = [newOrder, ...newData.orders.orders];

//           const newTotalCount = prev.orders.totalCount + 1;
//           const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

//           newData.orders = {
//             ...newData.orders,
//             totalCount: newTotalCount,
//             totalPages: newTotalPages,
//             orders: updatedOrders,
//           };
//         }
//         if (subscriptionData.data.orders.action === 'UPDATED') {
//           newData.orders.orders[indexFound] =
//             subscriptionData.data.orders.order;
//         }

//         if (subscriptionData.data.orders.action === 'DELETED') {
//           const { id } = subscriptionData.data.orders.order; // ID of the order to remove
//           const prevOrders = prev.orders.orders;

//           const updatedOrders = prevOrders.filter((val) => val.id !== id);

//           const newTotalCount = prev.orders.totalCount - 1;
//           const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

//           const updatedOrdersData = {
//             ...newData.orders,
//             totalCount: newTotalCount,
//             totalPages: newTotalPages,
//             orders: updatedOrders,
//           };

//           newData.orders = updatedOrdersData;
//         }
//         return newData;
//       },
//     });

//     return () => unsubscribe();
//   }, []);

//   if (loading) return <Loader />;
//   if (error) {
//     return <ErrorMessage error={error} />;
//   }
//   if (!data?.orders?.orders)
//     return <NoDataFound message="Orders not available" />;

//   const onToggle = () => {
//     dispatch(toggleModal({ showForm: false }))
//   }

//   return (
//     <>
//       {showAdvancedSearchBar && data?.orders?.orders?.length > 0 && (
//         <FilterResultBar
//           length={data?.orders?.orders?.length}
//           type="orders"
//           handleResetFilter={handleResetFilter}
//         />
//       )}
//       {pendingOrders?.showForm ? (
//           <PendingOrdersWrapper onActionClick={onClickEdit} open={pendingOrders?.showForm} toggleAlert={onToggle} title="Pending Actions" />
//       ) : null}
//       {updateOrderModal ? (
//         <FSBModal
//           title="Edit Order"
//           closeButtonLabel=""
//           confirmButtonLabel=""
//           message=""
//           open={updateOrderModal}
//           onClose={onCloseOrderPopup}
//           toggleAlert={onCloseOrderPopup}
//           modalClass="right-drawer-v2"
//         >
//           <EditOrderWrapper
//             currentRow={selectedOrderRow}
//             onCloseOrderPopup={onCloseOrderPopup}
//           />
//         </FSBModal>
//       ) : null}

//       <DeleteConfirmationAlert
//         open={showDeleteRecord}
//         title="Delete"
//         message="Do you really want to remove this record?"
//         cancelButtonLabel="Close"
//         addButtonLabel="Delete"
//         onConfirm={onDeleteConfirmation}
//         onCancel={toggleOnCancel}
//       />
//       <DeleteConfirmationAlert
//         open={showQuantity}
//         title=""
//         message="Do you really want to remove this record?"
//         cancelButtonLabel="Close"
//         addButtonLabel="Okay"
//         onConfirm={() => setShowQuantity(!showQuantity)}
//         onCancel={() => setShowQuantity(!showQuantity)}
//       />
//       {/* <DeleteConfirmationAlert
//         open={showDeliveredStatusRecord?.status}
//         title=""
//         message="Are you sure, Is order payment done?"
//         cancelButtonLabel="No"
//         addButtonLabel="Yes"
//         confirmButtonColor="primary"
//         onConfirm={onDeliveredStatusConfirmation}
//         onCancel={toggleDeliveredStatusRecord}
//       /> */}
//       {showDeliveredStatusRecord?.status && (
//         <FSBModal
//           title="Update Status"
//           open={showDeliveredStatusRecord?.status}
//           toggleAlert={toggleDeliveredStatusRecord}
//           onClose={toggleDeliveredStatusRecord}
//           message=""
//         >
//           <EditDeliveredQuantity
//             drawerToggle={toggleDeliveredStatusRecord}
//             onDeliveredStatusConfirmation={onDeliveredStatusConfirmation}
//             deliveredQuantity={showDeliveredStatusRecord?.row?.quantity}
//           />
//         </FSBModal>
//       )}
//       <DownloadCSV
//         lazyQuery={EXPORTS_ORDERS}
//         filters={filters}
//         apiKey="exportOrders"
//         fileName="Orders"
//         positionTop="-34px"
//       />
//       <FSBTable
//         columns={orderedColumns}
//         data={(data && data?.orders?.orders) || []}
//         totalCount={(data && data?.orders?.totalCount) || 0}
//         totalPages={(data && data?.orders?.totalPages) || 0}
//         currentPageNo={filters.pageNo}
//         pageSize={filters.pageSize}
//         keyField="id"
//         showSearch={false}
//         showFilters
//         showDelete={false}
//         showPagination
//         remote
//         tableClass="action-table order-table"
//         striped={false}
//         hover={false}
//         bordered={false}
//         wrapperClass="table-responsive word-break "
//         handlePageChange={handlePageChange}
//         globalSearchStr={filters.filter[0].value}
//         onGlobalSearch={onGlobalSearch}
//         onSortChange={onSortChange}
//         sorting={sortBy}
//         searchPlaceholder="Search Orders"
//       >
//         {/* Only can see add and delete buttons as Only admin can add or delete users */}
//       </FSBTable>
//     </>
//   );
// };
// export default OrderedTable;

import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation, useLazyQuery, useQuery } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { FSBTable } from 'components/common/FSBTable';
import {
  DELETE_ORDER,
  EXPORTS_ORDERS,
  ORDERED,
  UPDATE_ORDER_STATUS,
  UPDATE_PAYMENT_STATUS,
} from 'pages/Orders/OrdersGraphQL';
import {
  defaultDeleteFilter,
  handlePaymentStatusColor,
  PAYMENT_STATUS,
  showSequenceNumber,
  USER_ID,
} from 'utils/constants';
import {
  RECORD_DELETED_SUCCESSFULLY,
  STATUS_UPDATED_SUCCESSFULLY,
} from 'components/common/FSBToastify/types';
import { toggleModal } from 'actions/orderDetailsAction';
import { setUserDetails } from 'actions/userDetailsAction';
import { orderedColumns } from 'pages/Orders/constant';
import { role } from 'config/role';

import FSBModal from 'components/common/FSBModal';
import EditOrderWrapper from 'pages/Orders/components/EditOrderWrapper';
import DeleteConfirmationAlert from 'components/DeleteConfirmationAlert';
import ActionsFormatter from 'components/ActionsFormatter';
import StatusFormatter from 'components/StatusFormatter';
import RBAC from 'hoc/RBAC';

import Loader from 'components/common/Loader';
import DownloadCSV from 'components/DownloadCSV';

import NoDataFound from 'components/NoDataFound';
import ErrorMessage from 'components/ErrorMessage';

import FilterResultBar from 'components/FilterResultBar';
import PendingOrdersWrapper from 'pages/Orders/components/PendingOrders';
import KanbanView from './kanbanview';
import EditDeliveredQuantity from '../EditDeliveredQuantity';

const ALL_STATUSES = [
  'PENDING',
  'IN_PROGRESS',
  'LOADING',
  'DISPATCHED',
  'DELIVERED',
  'DELETED',
  'CANCELLED',
];
const KANBAN_REFRESH_INTERVAL_MS = 30_000;

const OrderedTable = ({
  searchString,
  filterValue,
  defaultValue,
  showAdvancedSearchBar = false,
  handleResetFilter = () => { },
  activeView = 'kanban',
  orderStatusFilter = '',
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [deleteRowId, setDeleteRowId] = useState('');
  const [updateOrderModal, setUpdateOrderModal] = useState(false);
  const [selectedOrderRow, setSelectedOrderRow] = useState('');
  const [showDeleteRecord, setDeleteRecord] = useState(false);
  const [showQuantity, setShowQuantity] = useState(false);
  const statusRequestsRef = useRef({});

  // Separate state for each status
  const [statusData, setStatusData] = useState({
    PENDING: {
      orders: [],
      pageNo: 1,
      hasMore: true,
      loading: false,
      totalCount: 0,
    },
    IN_PROGRESS: {
      orders: [],
      pageNo: 1,
      hasMore: true,
      loading: false,
      totalCount: 0,
    },
    LOADING: {
      orders: [],
      pageNo: 1,
      hasMore: true,
      loading: false,
      totalCount: 0,
    },
    DISPATCHED: {
      orders: [],
      pageNo: 1,
      hasMore: true,
      loading: false,
      totalCount: 0,
    },
    DELIVERED: {
      orders: [],
      pageNo: 1,
      hasMore: true,
      loading: false,
      totalCount: 0,
    },
    DELETED: {
      orders: [],
      pageNo: 1,
      hasMore: true,
      loading: false,
      totalCount: 0,
    },
    CANCELLED: {
      orders: [],
      pageNo: 1,
      hasMore: true,
      loading: false,
      totalCount: 0,
    },
  });

  const [initialLoading, setInitialLoading] = useState(true);
  const [listFilters, setListFilters] = useState({
    filter: [
      {
        key: 'globalSearch',
        value: searchString,
        type: 'STRING',
        op: 'LIKE',
      },
      { ...defaultDeleteFilter },
      ...defaultValue,
    ],
    pageNo: 1,
    pageSize: 10,
    sortCol: 'createdAt',
    sortDirection: 'DESC',
  });

  // Create lazy query for fetching orders
  const [fetchOrders] = useLazyQuery(ORDERED, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  });

  const getListQueryVariables = useCallback(() => {
    if (orderStatusFilter === 'DELETED') {
      return {
        ...listFilters,
        filter: [
          {
            key: 'globalSearch',
            value: searchString,
            type: 'STRING',
            op: 'LIKE',
          },
          {
            key: 'isDeleted',
            value: 'true',
            type: 'BOOLEAN',
            op: 'EQ',
          },
          ...defaultValue,
          ...filterValue,
        ],
      };
    }

    if (orderStatusFilter === 'PENDING') {
      return {
        ...listFilters,
        filter: [
          {
            key: 'globalSearch',
            value: searchString,
            type: 'STRING',
            op: 'LIKE',
          },
          {
            key: 'isDeleted',
            value: 'true',
            type: 'BOOLEAN',
            op: 'NEQ',
          },
          ...defaultValue,
          {
            key: 'approvalStatus',
            value: 'ORDER_APPROVAL_PENDING,ORDER_APPROVAL_EXPIRED',
            type: 'STRING',
            op: 'IN',
          },
          ...filterValue,
        ],
      };
    }

    return {
      ...listFilters,
      filter: [
        ...listFilters.filter,
        ...(orderStatusFilter
          ? [
            {
              key: 'status',
              value: orderStatusFilter,
              type: 'STRING',
              op: 'EQ',
            },
          ]
          : []),
        ...filterValue,
      ],
    };
  }, [defaultValue, filterValue, listFilters, orderStatusFilter, searchString]);

  const {
    data: listData,
    loading: listLoading,
    error: listError,
    refetch: refetchList,
  } = useQuery(ORDERED, {
    variables: getListQueryVariables(),
    fetchPolicy: 'network-only',
    skip: activeView !== 'listing',
  });

  const { pendingOrders } = useSelector((state) => state.orderDetailsReducer);

  const [showDeliveredStatusRecord, setShowDeliveredStatusRecord] = useState({
    id: '',
    orderStatus: '',
    status: false,
    row: '',
  });

  const baseFilters = useMemo(
    () => ({
      filter: [
        {
          key: 'globalSearch',
          value: searchString,
          type: 'STRING',
          op: 'LIKE',
        },
        { ...defaultDeleteFilter },
        ...defaultValue,
      ],
      pageSize: 10,
      sortCol: 'createdAt',
      sortDirection: 'DESC',
    }),
    [defaultValue, searchString],
  );

  const activeStatuses = useMemo(
    () => (orderStatusFilter ? [orderStatusFilter] : ALL_STATUSES),
    [orderStatusFilter],
  );

  // ✅ NEW: Create filter for deleted orders
  const createDeletedOrdersFilter = useCallback(
    (pageNo) => ({
      filter: [
        {
          key: 'globalSearch',
          value: searchString,
          type: 'STRING',
          op: 'LIKE',
        },
        {
          key: 'isDeleted',
          value: 'true',
          type: 'BOOLEAN',
          op: 'EQ',
        },
        ...defaultValue,
        ...filterValue,
      ],
      pageNo,
      pageSize: 10,
      sortCol: 'createdAt',
      sortDirection: 'DESC',
    }),
    [defaultValue, filterValue, searchString],
  );

  // ✅ NEW: Create filter for pending orders
  const createPendingOrdersFilter = useCallback(
    (pageNo) => ({
      filter: [
        {
          key: 'globalSearch',
          value: searchString,
          type: 'STRING',
          op: 'LIKE',
        },
        {
          key: 'isDeleted',
          value: 'true',
          type: 'BOOLEAN',
          op: 'NEQ',
        },
        ...defaultValue,
        {
          key: 'approvalStatus',
          value: 'ORDER_APPROVAL_PENDING,ORDER_APPROVAL_EXPIRED',
          type: 'STRING',
          op: 'IN',
        },
        ...filterValue,
      ],
      pageNo,
      pageSize: 10,
      sortCol: 'createdAt',
      sortDirection: 'DESC',
    }),
    [defaultValue, filterValue, searchString],
  );

  // ✅ Use statusValueMap so backend receives correct casing
  const createStatusFilter = useCallback(
    (status, pageNo) => {
      // Special handling for DELETED status
      if (status === 'DELETED') {
        return createDeletedOrdersFilter(pageNo);
      }

      // Special handling for PENDING status
      if (status === 'PENDING') {
        return createPendingOrdersFilter(pageNo);
      }

      return {
        ...baseFilters,
        pageNo,
        filter: [
          ...baseFilters.filter,
          {
            key: 'status',
            value: status,
            type: 'STRING',
            op: 'EQ',
          },
          ...filterValue,
        ],
      };
    },
    [
      baseFilters,
      createDeletedOrdersFilter,
      createPendingOrdersFilter,
      filterValue,
    ],
  );

  // Fetch function for each status
  const fetchStatusOrders = useCallback(
    async (
      status,
      pageNo = 1,
      isLoadMore = false,
      { background = false, preserveLoaded = false } = {},
    ) => {
      if (background && statusRequestsRef.current[status]) return;
      const requestToken = Symbol(status);
      statusRequestsRef.current[status] = requestToken;

      try {
        if (!background) {
          setStatusData((prev) => ({
            ...prev,
            [status]: { ...prev[status], loading: true },
          }));
        }

        const result = await fetchOrders({
          variables: createStatusFilter(status, pageNo),
        });
        if (statusRequestsRef.current[status] !== requestToken) return;

        if (result?.data?.orders?.orders) {
          const newOrders = result.data.orders.orders;
          const { totalCount } = result.data.orders;
          const totalLoaded = pageNo * 10; // pageSize is 10
          const getUpdatedOrders = (previousOrders) => {
            if (isLoadMore) {
              const loadedOrderIds = new Set(
                previousOrders.map((order) => order.id),
              );
              return [
                ...previousOrders,
                ...newOrders.filter((order) => !loadedOrderIds.has(order.id)),
              ];
            }
            if (!preserveLoaded || totalCount === 0) return newOrders;

            const refreshedOrderIds = new Set(
              newOrders.map((order) => order.id),
            );
            return [
              ...newOrders,
              ...previousOrders.filter(
                (order) => !refreshedOrderIds.has(order.id),
              ),
            ];
          };

          setStatusData((prev) => ({
            ...prev,
            [status]: {
              orders: getUpdatedOrders(prev[status].orders),
              pageNo: preserveLoaded ? prev[status].pageNo : pageNo,
              hasMore: preserveLoaded
                ? prev[status].pageNo * 10 < totalCount
                : totalLoaded < totalCount,
              loading: background ? prev[status].loading : false,
              totalCount,
            },
          }));
        } else if (!background) {
          // No data returned — clear loading state
          setStatusData((prev) => ({
            ...prev,
            [status]: {
              ...prev[status],
              loading: background ? prev[status].loading : false,
              orders: isLoadMore || preserveLoaded ? prev[status].orders : [],
              totalCount: 0,
              hasMore: false,
            },
          }));
        }
      } catch (error) {
        if (statusRequestsRef.current[status] !== requestToken) return;
        console.error(`Error fetching ${status} orders:`, error);
        if (!background) toast.error(`Failed to load ${status} orders`);
        setStatusData((prev) => ({
          ...prev,
          [status]: {
            ...prev[status],
            loading: background ? prev[status].loading : false,
          },
        }));
      } finally {
        if (statusRequestsRef.current[status] === requestToken) {
          delete statusRequestsRef.current[status];
        }
      }
    },
    [createStatusFilter, fetchOrders],
  );

  const refreshAllStatuses = useCallback(() => {
    activeStatuses.forEach((status) => fetchStatusOrders(status, 1, false));
  }, [activeStatuses, fetchStatusOrders]);

  // Load more handler for specific status
  const handleLoadMore = async (status) => {
    const currentStatus = statusData[status];

    if (currentStatus.loading || !currentStatus.hasMore) {
      return;
    }

    const nextPage = currentStatus.pageNo + 1;
    await fetchStatusOrders(status, nextPage, true);
  };

  // ✅ Single useEffect for initial load + filter/search changes
  useEffect(() => {
    const loadAllStatuses = async () => {
      setInitialLoading(true);

      try {
        await Promise.all(
          activeStatuses.map((status) => fetchStatusOrders(status, 1, false))
        );
      } finally {
        setInitialLoading(false);
      }
    };

    loadAllStatuses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchString, filterValue, orderStatusFilter]);

  useEffect(() => {
    setListFilters((prev) => ({
      ...prev,
      pageNo: 1,
      filter: [
        {
          key: 'globalSearch',
          value: searchString,
          type: 'STRING',
          op: 'LIKE',
        },
        { ...defaultDeleteFilter },
        ...defaultValue,
      ],
    }));
  }, [defaultValue, filterValue, orderStatusFilter, searchString]);

  useEffect(() => {
    const handleOrderCreated = () => {
      refreshAllStatuses();
      setListFilters((prev) => ({
        ...prev,
        pageNo: 1,
      }));
      refetchList?.({
        ...getListQueryVariables(),
        pageNo: 1,
      });
    };

    window.addEventListener('orderCreated', handleOrderCreated);
    return () => {
      window.removeEventListener('orderCreated', handleOrderCreated);
    };
  }, [getListQueryVariables, refetchList, refreshAllStatuses]);

  const refreshKanbanStatuses = useCallback(() => {
    if (document.visibilityState !== 'visible') return;

    activeStatuses.forEach((status) => {
      fetchStatusOrders(status, 1, false, {
        background: true,
        preserveLoaded: true,
      });
    });
  }, [activeStatuses, fetchStatusOrders]);

  useEffect(() => {
    if (activeView !== 'kanban') return undefined;

    refreshKanbanStatuses();
    const refreshInterval = window.setInterval(
      refreshKanbanStatuses,
      KANBAN_REFRESH_INTERVAL_MS,
    );

    return () => window.clearInterval(refreshInterval);
  }, [activeView, refreshKanbanStatuses]);

  const [deleteOrder] = useMutation(DELETE_ORDER, {
    onCompleted: ({ deleteOrder: deletedOrder }) => {
      if (deletedOrder) {
        toast.success(RECORD_DELETED_SUCCESSFULLY);
        setDeleteRecord(false);
        setDeleteRowId('');
        refreshAllStatuses();
        refetchList?.();
      }
    },
    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ exception }) => {
        toast.error(exception?.message);
        return exception;
      });
      setDeleteRecord(false);
      setDeleteRowId('');
    },
  });

  const [updateOrderStatus] = useMutation(UPDATE_ORDER_STATUS, {
    onCompleted: () => {
      toast.success(STATUS_UPDATED_SUCCESSFULLY);
      refreshAllStatuses();
      refetchList?.();
    },
    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ exception }) => {
        toast.error(exception?.message);
        return exception;
      });
    },
  });

  const [updateOrderPaymentStatus] = useMutation(UPDATE_PAYMENT_STATUS, {
    onCompleted: ({ updateOrderPaymentStatus: message }) => {
      toast.success(message);
      refetchList?.();
      refreshAllStatuses();
    },
    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ exception }) => {
        toast.error(exception?.message);
        return exception;
      });
    },
  });

  const onClickEdit = (row) => {
    setUpdateOrderModal(true);
    setSelectedOrderRow(row);
  };

  const onCloseOrderPopup = () => {
    setUpdateOrderModal(false);
    refreshAllStatuses();
    refetchList?.();
    setSelectedOrderRow('');
  };

  const onOrderUpdated = () => {
    refreshAllStatuses();
    refetchList?.();
  };

  const toggleDeleteRecord = (row) => {
    setDeleteRecord(!showDeleteRecord);
    setDeleteRowId(row);
  };

  const toggleOnCancel = () => {
    setDeleteRecord(false);
    setDeleteRowId('');
  };

  const onDeleteConfirmation = async () => {
    if (deleteRowId?.approvalStatus === 'ORDER_APPROVED') {
      setDeleteRecord(false);
      setDeleteRowId('');
      toast.warn("Approved order can't be deleted");
      return;
    }

    try {
      await deleteOrder({
        variables: { id: deleteRowId?.id },
      });
    } catch (e) {
      console.error(e);
    }
  };

  const handleViewDetail = (row) => {
    navigate(`/orders/${row?.id}`);
  };

  const handleOrderLinkClick = (row) => {
    navigate(`/orders/${row?.id}`);
  };

  const handleUserId = (row, id) => {
    dispatch(setUserDetails({ status: true, selectedUser: { ...row, id } }));
  };

  const handlePaymentStatusChange = async (e, cell) => {
    if (cell?.row?.original?.approvalStatus === 'ORDER_APPROVED') {
      try {
        await updateOrderPaymentStatus({
          variables: {
            id: cell?.row?.original?.id,
            paymentStatus: e.target.value,
          },
        });
      } catch (err) {
        toast.error(err);
      }
    } else {
      toast.error('Cannot update status before order approval');
    }
  };

  const handleListPageChange = ({ pageSize, pageNo }) => {
    setListFilters((prev) => ({
      ...prev,
      pageNo,
      pageSize,
    }));
  };

  const onListSortChange = (sort) => {
    const [nextSort] = sort();
    setListFilters((prev) => ({
      ...prev,
      sortCol: nextSort.id,
      sortDirection: nextSort.desc ? 'DESC' : 'ASC',
    }));
  };

  const onGlobalSearch = (str) => {
    setListFilters((prev) => {
      const updatedFilter = [...prev.filter];
      updatedFilter[0] = {
        key: 'globalSearch',
        value: str,
        type: 'STRING',
        op: 'LIKE',
      };
      return { ...prev, pageNo: 1, filter: updatedFilter };
    });
  };

  const listSortBy = [
    listFilters.sortCol === null
      ? { id: null, desc: null }
      : {
        id: listFilters.sortCol,
        desc: listFilters.sortDirection === 'DESC',
      },
  ];

  const listColumns = (() => {
    const columns = orderedColumns.map((column) => ({ ...column }));
    const findIndexOfItem = (item) =>
      columns.findIndex((column) => column.accessorKey === item);

    const actionsIndex = findIndexOfItem('actions');
    if (actionsIndex >= 0) {
      columns[actionsIndex].cell = (cell) => (
        <ActionsFormatter
          handleDelete={() => toggleDeleteRecord(cell?.row?.original)}
          handleView={() => handleOrderLinkClick(cell?.row?.original)}
          handleEdit={() => onClickEdit(cell?.row?.original)}
        />
      );
    }

    const paymentStatusIndex = findIndexOfItem('PaymentStatus');
    if (paymentStatusIndex >= 0) {
      columns[paymentStatusIndex].cell = (cell) => (
        <RBAC allowedRoles={[role.SUPER_ADMIN, role.ACCOUNT]} disabled>
          {({ access }) => (
            <StatusFormatter
              options={PAYMENT_STATUS}
              defaultValue={cell?.row?.original?.paymentStatus}
              handleChange={(e) => handlePaymentStatusChange(e, cell)}
              onChange={(e) => handlePaymentStatusChange(e, cell)}
              inputDisabled={!access}
              isStatus
              handleSelectColor={handlePaymentStatusColor}
            />
          )}
        </RBAC>
      );
    }

    const idIndex = findIndexOfItem('id');
    if (idIndex >= 0) {
      columns[idIndex].cell = (cell) => (
        <div
          className="text-blue-c5 fw-medium cursor-pointer"
          onClick={() => handleViewDetail(cell?.row?.original)}
          aria-hidden
        >
          {cell?.row?.original?.id}
        </div>
      );
    }

    const sequenceIndex = findIndexOfItem('SNo');
    if (sequenceIndex >= 0) {
      columns[sequenceIndex].cell = (cell) =>
        showSequenceNumber(cell, listFilters);
    }

    [USER_ID.CREATED_ID, USER_ID.UPDATED_ID].forEach((userId) => {
      const userIdIndex = findIndexOfItem(userId);
      if (userIdIndex >= 0) {
        columns[userIdIndex].cell = (cell) => (
          <div
            className="text-blue-c5 fw-medium cursor-pointer"
            onClick={() =>
              handleUserId(cell?.row?.original, cell?.row?.original?.[userId])
            }
            aria-hidden
          >
            {cell?.row?.original?.[userId]}
          </div>
        );
      }
    });

    return columns;
  })();

  const toggleDeliveredStatusRecord = (id = '', orderStatus = '', row = '') => {
    setShowDeliveredStatusRecord({
      id,
      orderStatus,
      status: !showDeliveredStatusRecord?.status,
      row,
    });
  };

  const handleOrderStatus = async (id, status, deliveredQuantity = null) => {
    try {
      await updateOrderStatus({
        variables: { id, status, deliveredQuantity },
      });
    } catch (err) {
      toast.error(err);
    }
  };

  const onDeliveredStatusConfirmation = (deliveredQuantity = null) => {
    handleOrderStatus(
      showDeliveredStatusRecord?.id,
      showDeliveredStatusRecord?.orderStatus,
      deliveredQuantity,
    );
    toggleDeliveredStatusRecord('', '', '');
  };

  if (initialLoading) return <Loader />;

  // Check if all statuses have no orders
  const hasAnyOrders = activeStatuses.some(
    (status) => statusData[status]?.orders?.length > 0,
  );

  if (!hasAnyOrders) {
    return <NoDataFound message="Orders not available" />;
  }

  if (activeView === 'listing' && listError) {
    return <ErrorMessage error={listError} />;
  }

  const onToggle = () => {
    dispatch(toggleModal({ showForm: false }));
  };

  return (
    <>
      {showAdvancedSearchBar && hasAnyOrders && (
        <FilterResultBar
          length={activeStatuses.reduce(
            (sum, status) => sum + (statusData[status]?.orders?.length || 0),
            0,
          )}
          type="orders"
          handleResetFilter={handleResetFilter}
        />
      )}

      {pendingOrders?.showForm ? (
        <PendingOrdersWrapper
          onActionClick={onClickEdit}
          open={pendingOrders?.showForm}
          toggleAlert={onToggle}
          title="Pending Actions"
        />
      ) : null}

      {updateOrderModal ? (
        <FSBModal
          title="Edit Order"
          closeButtonLabel=""
          confirmButtonLabel=""
          message=""
          open={updateOrderModal}
          onClose={onCloseOrderPopup}
          toggleAlert={onCloseOrderPopup}
          modalClass="right-drawer-v2"
        >
          <EditOrderWrapper
            currentRow={selectedOrderRow}
            onCloseOrderPopup={onCloseOrderPopup}
            onOrderUpdated={onOrderUpdated}
          />
        </FSBModal>
      ) : null}

      <DeleteConfirmationAlert
        open={showDeleteRecord}
        title="Delete"
        message="Do you really want to remove this record?"
        cancelButtonLabel="Close"
        addButtonLabel="Delete"
        onConfirm={onDeleteConfirmation}
        onCancel={toggleOnCancel}
      />

      <DeleteConfirmationAlert
        open={showQuantity}
        title=""
        message="Do you really want to remove this record?"
        cancelButtonLabel="Close"
        addButtonLabel="Okay"
        onConfirm={() => setShowQuantity(!showQuantity)}
        onCancel={() => setShowQuantity(!showQuantity)}
      />

      {showDeliveredStatusRecord?.status && (
        <FSBModal
          title="Update Status"
          open={showDeliveredStatusRecord?.status}
          toggleAlert={toggleDeliveredStatusRecord}
          onClose={toggleDeliveredStatusRecord}
          message=""
        >
          <EditDeliveredQuantity
            drawerToggle={toggleDeliveredStatusRecord}
            onDeliveredStatusConfirmation={onDeliveredStatusConfirmation}
            deliveredQuantity={showDeliveredStatusRecord?.row?.quantity}
          />
        </FSBModal>
      )}

      <DownloadCSV
        lazyQuery={EXPORTS_ORDERS}
        filters={getListQueryVariables()}
        apiKey="exportOrders"
        fileName="Orders"
        positionTop="-40px"
      />

      {activeView === 'listing' ? (
        <FSBTable
          columns={listColumns}
          data={(listData && listData?.orders?.orders) || []}
          totalCount={(listData && listData?.orders?.totalCount) || 0}
          totalPages={(listData && listData?.orders?.totalPages) || 0}
          currentPageNo={listFilters.pageNo}
          pageSize={listFilters.pageSize}
          keyField="id"
          showSearch={false}
          showFilters
          showDelete={false}
          showPagination
          remote
          loading={listLoading}
          tableClass="action-table order-table"
          striped={false}
          hover={false}
          bordered={false}
          wrapperClass="table-responsive word-break"
          tableWraperClass="min-h-table"
          handlePageChange={handleListPageChange}
          globalSearchStr={listFilters.filter[0].value}
          onGlobalSearch={onGlobalSearch}
          onSortChange={onListSortChange}
          sorting={listSortBy}
          searchPlaceholder="Search Orders"
        />
      ) : (
        <KanbanView
          statusData={statusData}
          visibleStatuses={activeStatuses}
          onClickEdit={onClickEdit}
          handleViewDetail={handleViewDetail}
          handleOrderLinkClick={handleOrderLinkClick}
          toggleDeleteRecord={toggleDeleteRecord}
          onLoadMore={handleLoadMore}
        />
      )}
    </>
  );
};

export default OrderedTable;
